<template>
  <nav class="tw-space-y-1" aria-label="Sidebar">
    <router-link
        v-for="item in items"
        :key="item.name"
        :to="item.to"
        :class="[isCurrent(item) ? 'tw-bg-gray-200 tw-text-gray-900' : 'tw-text-gray-600 tw-hover:bg-gray-50 tw-hover:text-gray-900', 'tw-group tw-flex tw-items-center tw-px-3 tw-py-2 tw-font-medium tw-rounded-md']"
    >
      <component
          :is="item.icon"
          :class="[isCurrent(item) ? 'tw-text-gray-500' : 'tw-text-gray-400 tw-group-hover:text-gray-500', 'tw-flex-shrink-0 tw--ml-1 tw-mr-3 tw-h-6 tw-w-6']"
      />

      <span class="tw-truncate">{{ item.name }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  props: {
    items: {
      required: true
    }
  },

  methods: {
    isCurrent(item) {
      if (item.group) {
        return this.$route.path.startsWith(item.to)
      }

      return this.$route.path === item.to
    }
  }
}
</script>
